<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Lisensi Aktif</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Lisensi Aktif</li>
                </ul>
              </div>
              <!-- <div class="col-auto float-right ml-auto">
                <router-link :to="'/subscriptions'" class="btn add-btn">
                  <i class="fa fa-shopping-cart"></i> Order
                </router-link>
              </div> -->
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.columnFilters.period" type="month" />
                <label class="focus-label">Period</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <div class="input-group">
                  <input class="form-control floating" v-model="serverParams.columnFilters.keywords" type="text"
                    placeholder="Name, Email, Mobile Phone" />
                  <label class="focus-label">Search</label>
                  <div class="input-group-append">
                    <a title="Show search options" class="btn btn-primary" @click="
                      $store.dispatch('utils/setModalData', {
                        showModal: true
                      })
                      " href="#" data-toggle="modal" data-target="#search_form">
                      <i class="fa fa-list"></i>
                      <i class="fa fa-circle" v-if="serverParams.more_search == true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <ModalFilter @clear="resetFilter" @searchData="
              () => {
                serverParams.more_search = true;
                searchData();
              }
            ">
              <template>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Period</label>
                    <input class="form-control col-md-6" v-model="serverParams.columnFilters.period" type="month" />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Search</label>
                    <input class="form-control col-md-6" v-model="serverParams.columnFilters.keywords" type="text"
                      placeholder="Name, Email, Mobile Phone" />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Online Status</label>
                    <a-select class="col-md-6 px-0" size="large" v-model="serverParams.columnFilters.is_online_status">
                      <a-select-option value>&nbsp;</a-select-option>
                      <a-select-option value="online">Online</a-select-option>
                      <a-select-option value="offline">Offline</a-select-option>
                    </a-select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Jenis Lisensi</label>
                    <a-select class="col-md-6 px-0" size="large" v-model="serverParams.columnFilters.is_free">
                      <a-select-option value>&nbsp;</a-select-option>
                      <a-select-option value="0">Berbayar</a-select-option>
                      <a-select-option value="1">Gratis/Free Trial</a-select-option>
                    </a-select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Feature</label>
                    <a-select v-model="serverParams.columnFilters.feature" placeholder="Feature" class="col-md-6 px-0 "
                      allowClear size="large">
                      <a-select-option v-for="item in featureList" :key="item.value" :value="item.value">
                        {{ item.label }}
                      </a-select-option>
                    </a-select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">No Whatsapp</label>
                    <input class="form-control col-md-6" v-model="serverParams.columnFilters.license_phone_number"
                      type="text" />
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Sisa Masa Aktif</label>
                    <a-select v-model="serverParams.columnFilters.remaining_active_period" placeholder="Sisa Masa Aktif"
                      class="col-md-6 px-0 " allowClear size="large">
                      <a-select-option value>&nbsp;</a-select-option>
                      <a-select-option value="today">Hari Ini</a-select-option>
                      <a-select-option value="1_day_left">1 Hari Lagi</a-select-option>
                      <a-select-option value="3_day_left">3 Hari Lagi</a-select-option>
                      <a-select-option value="7_day_left">7 Hari Lagi</a-select-option>
                      <a-select-option value="15_day_left">15 Hari Lagi</a-select-option>
                      <a-select-option value="30_day_left">30 Hari Lagi</a-select-option>
                    </a-select>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="form-group row">
                    <label class="col-form-label col-md-6">Waktu Dibuat</label>
                    <a-select v-model="serverParams.columnFilters.create_license" placeholder="Sisa Masa Aktif"
                      class="col-md-6 px-0 " allowClear size="large">
                      <a-select-option value>&nbsp;</a-select-option>
                      <a-select-option value="today">Hari Ini</a-select-option>
                      <a-select-option value="just_3_days">Baru 3 hari</a-select-option>
                      <a-select-option value="just_7_days">Kurang dari 7 hari</a-select-option>
                      <a-select-option value="just_30_days">Kurang dari 30 hari</a-select-option>
                    </a-select>
                  </div>
                </div>
              </template>
            </ModalFilter>
            <div class="col-sm-6 col-md-3">
              <a href="javascript:void(0)" @click.prevent="searchData" class="btn btn-success btn-block">Search</a>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row  filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group row">
                <label class="col-form-label col-md-3">Urutkan</label>
                <a-select @change="searchData" v-model="serverParams.orderBy" placeholder="Urutkan Data"
                  class="col-md-6 px-0 " allowClear size="large">
                  <template v-for="(value, key) in orderByList">
                    <a-select-option :value="key">{{ value }}</a-select-option>
                  </template>
                </a-select>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <button :disabled="isLoading" @click="listLicenseActiveExcel" class="btn btn-sm btn-primary">
                <i class="fa fa-download"></i> Excel
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <div v-if="linkDownload != ''" class="alert alert-success">Data berhasil dibuat, silakan klik <a
                    :href="linkDownload" target="_blank">link</a> berikut jika download otomatis tidak berfungsi. <a
                    class="text-danger" @click="closeMessageLinkDownload"><i class="fa fa-remove"></i></a></div>

                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center" style="width:100px;">
                        Member Name
                      </th>
                      <th class="text-center" style="width:100px;">
                        Member Phone
                      </th>
                      <th class="text-center" style="width:100px;">
                        License Name
                      </th>
                      <th class="text-center">Email</th>
                      <th class="text-center">No Whatsapp</th>
                      <th class="text-center">Status Aktif</th>
                      <!-- <th class="text-center">Last Online</th> -->
                      <th class="text-center">Masa Aktif</th>
                      <th class="text-center">Waktu Dibuat</th>
                      <!-- <th>Action</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="6">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td class="text-right">{{ row.number }}</td>
                        <td>{{ row.member_name }}</td>
                        <td>{{ row.member_mobilephone }}</td>
                        <td>{{ row.license_name }}</td>
                        <td>{{ row.member_email }}</td>
                        <td>{{ row.license_phone_number }}
                          <br />
                          <template v-if="row.is_free == '0'">
                            <span class="badge badge-info">Berbayar</span>
                            <br /><span class="badge badge-primary">{{ row.last_product_name }}</span>
                          </template>
                          <template v-else>
                            <span class="badge badge-warning">Free Trial/Gratis</span>
                          </template>
                        </td>
                        <td>
                          <span class="badge" :class="row.is_online_status == '1'
                            ? 'badge-success'
                            : 'badge-danger'
                            ">{{
                              row.is_online_status == "1" ? "Online" : "Offline"
                            }}</span>
                          <br />
                          <small>{{
                            $moment
                              .unix(row.is_online_last_time)
                              .format("YYYY-MM-DD HH:mm:ss")
                          }}</small>
                        </td>
                        <!-- <td></td> -->
                        <td>
                          {{ row.license_masa_aktif }} <br />
                          <div v-html="row.remaining_active_period"></div>
                        </td>
                        <td>{{ formatLocalDate(convertUTCDatetimeToUnix(row.license_create_datetime)) }}</td>
                      </tr>
                    </template>
                    <template v-if="loading">
                      <tr>
                        <td colspan="6">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="5" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
                v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input style="width:100px;" min="1" type="number" v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))" class />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                class="footer__navigation__page-btn" :class="'btn ' +
                {
                  disabled:
                    parseInt(currentPage) + 1 >
                    Math.ceil(totalRecords / serverParams.perPage)
                }
                  ">
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import {
  convertUTCDatetimeToUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  getWhatsappNumberFromJid,
  formatPriceRupiah
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import ModalFilter from "@/components/ModalFilter";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    ModalFilter
  },
  data() {
    return {
      linkDownload: '',
      isLoading: false,
      loading: false,
      rows: [],
      orderByList: {
        "license_create_datetime_desc": "Tgl Dibuat [Z-A]",
        "license_create_datetime_asc": "Tgl Dibuat [A-Z]",
        "license_masa_aktif_desc": "Masa Aktif [Z-A]",
        "license_masa_aktif_asc": "Masa Aktif [A-Z]"
      },
      totalRecords: 0,
      currentPage: 1,
      featureList: [
        {
          label: "Not Yet Broadcast",
          value: "not_yet_broadcast"
        },
        {
          label: "Not Yet Chatbot",
          value: "not_yet_chatbot"
        },
        {
          label: "Not Yet AI Chatbot",
          value: "not_yet_ai_chatbot"
        },
        {
          label: "Not Yet Birthday Greetings",
          value: "not_yet_birthday_greetings"
        },
        {
          label: "Not Yet Panen Kontak",
          value: "not_yet_panen_kontak"
        },
        {
          label: "Using Broadcast",
          value: "using_broadcast"
        },
        {
          label: "Using Chatbot",
          value: "using_chatbot"
        },
        {
          label: "Using AI Chatbot",
          value: "using_ai_chatbot"
        },
        {
          label: "Using Birthday Greetings",
          value: "using_birthday_greetings"
        },
        {
          label: "Using Panen Kontak",
          value: "using_panen_kontak"
        }
      ],
      rowPage: 1,
      serverParams: {
        columnFilters: {
          period: "",
          keywords: "",
          feature: null,
          is_online_status: "",
          license_phone_number: "",
          remaining_active_period: "",
          is_free: "",
          create_license: ""
        },
        orderBy: "license_create_datetime_desc",
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  created() {
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    closeMessageLinkDownload() {
      this.linkDownload = '';
    },
    listLicenseActiveExcel() {
      this.isLoading = true;
      this.$store
        .dispatch("member/listLicenseActiveExcel", this.serverParams)
        .then(response => {
          this.isLoading = false;
          this.linkDownload = response.data;
          if (this.linkDownload != '') {
            window.open(this.linkDownload, '_blank').focus();
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    convertUTCDatetimeToUnix(value) {
      return convertUTCDatetimeToUnix(value);
    },
    formatPriceRupiah(value) {
      return formatPriceRupiah(value);
    },

    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    resetFilter() {
      this.serverParams.columnFilters = {
        period: "",
        keywords: "",
        feature: "",
        is_online_status: "",
        license_phone_number: "",
        remaining_active_period: "",
        is_free: "",
        create_license: ""
      };
      this.serverParams.more_search = false;
      this.searchData();
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("member/listLicenseActive", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          console.log(data.data);
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%",
        allowClear: true
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "summary_"
};
</script>



// WEBPACK FOOTER //
// src/views/member/active-lisence.vue